var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Delete = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "9", height: "16" }, props),
        React.createElement("path", { fill: color, d: "M8 4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7zM2 5H1v10h1V5zm4 0H5v10h1V5zm2 0H7v10h1V5zM4 5H3v10h1V5zm1-5a1 1 0 0 1 1 1v1h2.5a.5.5 0 0 1 0 1h-8a.5.5 0 0 1 0-1H3V1a1 1 0 0 1 1-1h1zm0 1H4v1h1V1z" })));
};
Delete.defaultProps = {
    color: '#00C1B1',
};
export default Delete;
//# sourceMappingURL=Delete.js.map